import { ApolloLink } from '@apollo/client/core';
import { CompanyContextService } from 'src/app/shared/company-context.service';
import { isNullOrWhitespace } from 'src/util/string';
export function createAuthLink(companyContext: CompanyContextService): ApolloLink {
  return new ApolloLink((operation, forward) => {
    const operationContext = operation.getContext();
    const headers = operationContext.headers != null ? operationContext.headers : {};

    if (!isNullOrWhitespace(operation.operationName)) {
      headers['x-operation-name'] = operation.operationName;
    }

    // Assume we're in a new company context once routing guards have been run
    const company = companyContext.postGuardCompany;
    if (company != null) {
      headers['x-company-code'] = company.companyCode;
      headers['x-company-id'] = company.id;
    }

    operation.setContext({ headers });

    return forward != null ? forward(operation) : null;
  });
}
